import styled from 'styled-components';

import { IconComponent } from './types';

const DottedCurveIcon: IconComponent = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_776_74"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="12"
      height="12"
    >
      <rect width="12" height="12" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_776_74)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.65361 2.6938C1.3443 2.5593 1.02843 2.43641 0.706527 2.3257L1.35699 0.434431C1.72881 0.562309 2.09373 0.704275 2.45115 0.859697L1.65361 2.6938ZM5.06469 4.87211C4.55947 4.42326 4.01819 4.01359 3.44535 3.64776L4.5218 1.96216C5.18383 2.38494 5.80929 2.85833 6.39304 3.37695L5.06469 4.87211ZM7.63015 8.00291C7.28746 7.41593 6.8997 6.85874 6.47135 6.33602L8.01829 5.06836C8.51322 5.67232 8.96129 6.31617 9.35734 6.99452L7.63015 8.00291ZM8.84194 10.7923C8.74415 10.4662 8.63396 10.1457 8.51191 9.83126L10.3763 9.10749C10.5174 9.47082 10.6447 9.84112 10.7576 10.2177L8.84194 10.7923Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const RidgeIcon = styled(DottedCurveIcon)`
  transform: rotate(0deg);
` as IconComponent;

export const ValleyIcon = styled(DottedCurveIcon)`
  transform: rotate(180deg);
` as IconComponent;
